import { StepAcademicBackgroundComponent } from "../steps/step-academic-background/step-academic-background.component";
import { StepAcademicPerformanceComponent } from "../steps/step-academic-performance/step-academic-performance.component";
import { StepCareerMotivationsComponent } from "../steps/step-career-motivations/step-career-motivations.component";
import { StepCareerPreferencesComponent } from "../steps/step-career-preferences/step-career-preferences.component";
import { StepContactInformationComponent } from "../steps/step-contact-information/step-contact-information.component";
import { StepFinancialInformationComponent } from "../steps/step-financial-information/step-financial-information.component";
import { StepFuturePlansComponent } from "../steps/step-future-plans/step-future-plans.component";
import { StepGuardianInformationComponent } from "../steps/step-guardian-information/step-guardian-information.component";
import { StepIcfesReadinessComponent } from "../steps/step-icfes-readiness/step-icfes-readiness.component";
import { StepLanguageProficiencyComponent } from "../steps/step-language-proficiency/step-language-proficiency.component";
import { ColombiaSelectorComponent } from "../steps/step-location-preferences/colombia-selector/colombia-selector.component";
import { CountrySelectorComponent } from "../steps/step-location-preferences/country-selector/country-selector.component";
import { StepLocationPreferencesComponent } from "../steps/step-location-preferences/step-location-preferences.component";
import { StepPersonalInformationComponent } from "../steps/step-personal-information/step-personal-information.component";
import { StepSkillsComponent } from "../steps/step-skills/step-skills.component";
import { StepStandardizedTestsComponent } from "../steps/step-standardized-tests/step-standardized-tests.component";
import { StepStudyPreferenceComponent } from "../steps/step-study-preference/step-study-preference.component";
import { StepUniversityPreferencesComponent } from "../steps/step-university-preferences/step-university-preferences.component";
import { StepWelcomeComponent } from "../steps/step-welcome/step-welcome.component";
import { StepKey } from "./initial-form.enums";
import { StepConfig } from "./initialForm.models";

export const STEPS_CONFIG: StepConfig[] = [
    { key: StepKey.Welcome, title: '¡Bienvenido a U360!', description: 'Completa los siguientes pasos para comenzar tu proceso de orientación académica.' },
    { key: StepKey.PersonalInfo, title: 'Cuéntanos sobre ti', description: 'Ingresa tu nombre, apellido y otros datos básicos. ¡Queremos conocerte mejor!' },
    { key: StepKey.AcademicBackground, title: 'Información académica', description: 'Dinos en qué grado estás. Esto nos ayudará a ofrecerte información relevante para tu futuro.' },
    { key: StepKey.ContactInfo, title: 'Mantengámonos en contacto', description: 'Déjanos tu correo, teléfono y redes sociales para que podamos enviarte información valiosa sobre tu futuro académico.' },
    { key: StepKey.StudyPreferences, title: '¿Dónde te gustaría estudiar?', description: 'Cuéntanos en qué lugar del mundo te gustaría estudiar.' },
    { key: StepKey.AbroadLocation, title: '¿Dónde te gustaría estudiar en el exterior?', description: 'Selecciona los países de tu interés.' },
    { key: StepKey.ColombiaLocation, title: '¿Dónde te gustaría estudiar en Colombia?', description: 'Selecciona tus preferencias en Colombia.' },
    { key: StepKey.FuturePlans, title: 'Tu próximo paso después del colegio', description: 'Selecciona tu próximo paso después de la secundaria.' },
    { key: StepKey.UniversityPref, title: 'Tu estilo de aprendizaje y educación ideal', description: 'Elige el tipo de educación con el que más te identificas y que mejor se alinea con tus intereses y objetivos.' },
    { key: StepKey.CareerPref, title: 'Tu futuro profesional', description: 'Cuéntanos sobre las carreras que más te interesan, la que tienes en mente como tu primera opción y cuándo planeas comenzar tu camino universitario.' },
    { key: StepKey.AcademicPerf, title: 'Tus notas académicas', description: 'Ingresa tus notas académicas para que podamos ofrecerte información más precisa sobre tus opciones de estudio.' },
    { key: StepKey.Language, title: 'Nivel de Inglés', description: 'Cuéntanos sobre tu nivel de inglés.' },
    { key: StepKey.CareerMotivations, title: 'Motivación', description: 'Selecciona hasta tres motivaciones que te impulsan a escoger una carrera.' },
    { key: StepKey.StandardizedTests, title: 'Pruebas estándarizadas', description: 'Ingresa tus resultados de pruebas estandarizadas para que podamos ofrecerte información más precisa sobre tus opciones de estudio.' },
    { key: StepKey.Skills, title: 'Habilidades académicas y generales', description: 'Qué tan interesado estas de explorar las siguientes áreas del conocimiento ó habilidades.' },
    { key: StepKey.Financial, title: 'Información financiera', description: 'Cuéntanos sobre tu situación financiera para que podamos ofrecerte información más precisa sobre tus opciones de estudio.' },
    { key: StepKey.Icfes, title: 'Preparación para el ICFES', description: 'Cuéntanos cómo te estás preparando para el ICFES.' },
    { key: StepKey.Guardian, title: 'Información de tus acudientes', description: 'Ingresa la información de tus padres o acudientes.' }
];

export const STEP_COMPONENTS: Record<StepKey, any> = {
    [StepKey.Welcome]: StepWelcomeComponent,
    [StepKey.PersonalInfo]: StepPersonalInformationComponent,
    [StepKey.AcademicBackground]: StepAcademicBackgroundComponent,
    [StepKey.ContactInfo]: StepContactInformationComponent,
    [StepKey.StudyPreferences]: StepStudyPreferenceComponent,
    [StepKey.AbroadLocation]: CountrySelectorComponent,
    [StepKey.ColombiaLocation]: ColombiaSelectorComponent,
    [StepKey.FuturePlans]: StepFuturePlansComponent,
    [StepKey.UniversityPref]: StepUniversityPreferencesComponent,
    [StepKey.CareerPref]: StepCareerPreferencesComponent,
    [StepKey.AcademicPerf]: StepAcademicPerformanceComponent,
    [StepKey.Language]: StepLanguageProficiencyComponent,
    [StepKey.CareerMotivations]: StepCareerMotivationsComponent,
    [StepKey.StandardizedTests]: StepStandardizedTestsComponent,
    [StepKey.Skills]: StepSkillsComponent,
    [StepKey.Financial]: StepFinancialInformationComponent,
    [StepKey.Icfes]: StepIcfesReadinessComponent,
    [StepKey.Guardian]: StepGuardianInformationComponent
};


export const STEPS_UPDATE_PERSONAL_INFORMATION: StepKey[] = [
    StepKey.PersonalInfo,
    StepKey.AcademicBackground,
    StepKey.ContactInfo,
    StepKey.UniversityPref
  ];

export const getDynamicStepFlow = (studyInterest: string): StepConfig[] => {
    const beforeDynamic = [
        StepKey.Welcome,
        StepKey.PersonalInfo,
        StepKey.AcademicBackground,
        StepKey.ContactInfo,
        StepKey.StudyPreferences
    ];

    const dynamicStepsMap: Record<string, StepKey[]> = {
        'Mi pais': [StepKey.ColombiaLocation],
        'El exterior': [StepKey.AbroadLocation, StepKey.ColombiaLocation],
        'Aun no lo se': [StepKey.ColombiaLocation]
    };

    const afterDynamic = [
        StepKey.FuturePlans,
        StepKey.UniversityPref,
        StepKey.CareerPref,
        StepKey.AcademicPerf,
        StepKey.Language,
        StepKey.CareerMotivations,
        StepKey.StandardizedTests,
        StepKey.Skills,
        StepKey.Financial,
        StepKey.Icfes,
        StepKey.Guardian
    ];

    const dynamic = dynamicStepsMap[studyInterest] || [];

    const allStepKeys = [...beforeDynamic, ...dynamic, ...afterDynamic];
    return allStepKeys.map(key => STEPS_CONFIG.find(step => step.key === key)!);
};
